// Official logo of Fondazione Semi d'Impresa Luca Delle Donne
export const Logo = ({ variant = "dark", compact = false, className = "" }) => {
  // variant "dark" = navy mark/text (for light backgrounds)
  // variant "light" = white mark/text (for dark backgrounds)
  const src = compact
    ? variant === "light"
      ? "/brand/mark-white.png"
      : "/brand/mark-navy.png"
    : variant === "light"
    ? "/brand/logo-white.png"
    : "/brand/logo-navy.png";

  return (
    <div className={`flex items-center ${className}`} data-testid="brand-logo">
      <img
        src={src}
        alt="Fondazione Semi d'Impresa Luca Delle Donne"
        className={compact ? "h-10 w-auto" : "h-11 w-auto sm:h-12"}
        draggable={false}
      />
    </div>
  );
};

// Legacy named export kept for backwards compat with existing imports (if any)
export const SproutMark = ({ className = "", variant = "dark" }) => (
  <img
    src={variant === "light" ? "/brand/mark-white.png" : "/brand/mark-navy.png"}
    alt="Semi d'Impresa"
    className={className}
    draggable={false}
  />
);
